import React from "react";
import "./Tutorials.css";
import training from '../Assets/training.png';
const TechTutorials = () => {
    return (
        <section className="tech-tutorials">
            <div className="content">
                <div className="text">
                    <h3>Unlock Your Potential with Expert-Led Tech Tutorials</h3>
                    <p>
                        Dive into a world of technology with our comprehensive and engaging tutorials. 
                        Whether you're a beginner or an experienced developer, we provide step-by-step guides 
                        and tutorials to help you master the latest tools, frameworks, and techniques.
                    </p>
                    <p>
                        Our expert instructors will take you through real-world examples and projects that 
                        accelerate your learning and empower you to build innovative solutions.
                    </p>
                </div>
                <div className="image">
                    <img src={training} alt="Tech Tutorials" />
                </div>
            </div>
        </section>
    );
};

export default TechTutorials;
